/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getUserRole } from 'redux-app/selectors/auth'
import AccessWrapper from './AccessWrapper'

interface IProps {
  on?: string[],
  off?: string[],
}

export default compose<IProps, any>(
  connect(
    (state, { on, off = [] }) => {
      const userRole = getUserRole(state)
      if (on) {
        return {
          isAccessed: on.includes(userRole),
        }
      }
      return {
        isAccessed: !off.includes(userRole),
      }
    },
  ),
)(AccessWrapper)
